// Styles for CarouselGalleryTriptych go here.
import { baseVariables } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledCarouselGalleryTriptych = styled.div`
  .left-arrow,
  .right-arrow,
  .left-arrow::after,
  .right-arrow::before {
    color: ${baseVariables.color['base10']};
  }
  .glide__bullet--active::after {
    background-color: ${baseVariables.color['base10']};
  }

  .color-class {
    .left-arrow,
    .right-arrow,
    .left-arrow::after,
    .right-arrow::before {
      color: ${baseVariables.color['base20']};
    }
    .glide__bullet--active::after {
      background-color: ${baseVariables.color['base20']};
    }
  }
`;
